import { DraftOrder } from "./types";

const STORAGE_KEY_PREFIX = "pos:drafts:v1:";
const TTL_MS = 60 * 60 * 1000;

interface PersistedDrafts {
  savedAt: number;
  drafts: DraftOrder[];
  activeOrderId: string | null;
}

const keyFor = (restaurantId: string) => `${STORAGE_KEY_PREFIX}${restaurantId}`;

export function loadDrafts(
  restaurantId: string
): { drafts: DraftOrder[]; activeOrderId: string | null } | null {
  try {
    const raw = localStorage.getItem(keyFor(restaurantId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PersistedDrafts;
    if (Date.now() - parsed.savedAt > TTL_MS) {
      localStorage.removeItem(keyFor(restaurantId));
      return null;
    }
    return { drafts: parsed.drafts, activeOrderId: parsed.activeOrderId };
  } catch {
    return null;
  }
}

export function saveDrafts(
  restaurantId: string,
  drafts: DraftOrder[],
  activeOrderId: string | null
): void {
  try {
    if (drafts.length === 0) {
      localStorage.removeItem(keyFor(restaurantId));
      return;
    }
    const payload: PersistedDrafts = {
      savedAt: Date.now(),
      drafts,
      activeOrderId,
    };
    localStorage.setItem(keyFor(restaurantId), JSON.stringify(payload));
  } catch {
    // Storage might be full or unavailable — drafts simply won't persist.
  }
}
